var e = Object.fromEntries([
	"prod",
	"stag",
	"stag2",
	"dev1",
	"preprod"
].map((e) => [e, e === "prod" ? "dixa.io" : `euw1.${e}.dixa.io`]));
function t(t) {
	return new Set(Object.values(e)).has(t);
}
function n(t) {
	if (!t) return "prod";
	for (let [n, r] of Object.entries(e)) if (t === r) return n;
	return "prod";
}
// src/getParameter.ts
function r(e) {
	e = e.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
	let t = RegExp(`[\\?&]${e}=([^&#]*)`).exec(location.search);
	return t === null ? null : i(t[1].replace(/\+/g, " "));
}
function i(e) {
	try {
		return decodeURIComponent(e);
	} catch {
		return console.warn(`Failed to decode param value '${e}'`), e;
	}
}
// src/backendDomain.ts
var a = { backendDomain: "dixa:backend-domain" };
function o() {
	let e = r("staging") || r("backend-domain");
	if (e) {
		let n = /^\d+$/.test(e) ? `euw1.stag${e === "1" ? "" : e}.dixa.io` : e;
		return t(n) ? (c(n), n) : null;
	}
	return null;
}
function s() {
	let e = document.cookie.split("; ").find((e) => e.startsWith(`${a.backendDomain}=`)), n = e ? decodeURIComponent(e.split("=")[1]) : null;
	return n && !t(n) ? (l(), null) : n;
}
function c(e) {
	document.cookie = `${a.backendDomain}=${encodeURIComponent(e)}; path=/; max-age=31536000; SameSite=Lax`;
}
function l() {
	document.cookie = `${a.backendDomain}=; path=/; max-age=0`;
}
// src/index.ts
var u = window.location.origin.replace(/^https?:\/\//, ""), d = o() ?? s(), f = n(d), p = {
	develop: [
		"localhost:8080",
		"dixadev.com",
		"dixa.io"
	],
	test: {
		security: ["dixa-security.com", "dixa-security.net"],
		automation: [
			"localhost:9999",
			"test-agent-interface.dixa.io",
			"test.dixatest.com",
			"okta-test-org.dixatest.com"
		]
	},
	custom: [
		"thehaddaway.dixa.com",
		"demo.dixa.com",
		"developer.dixa.com",
		"okta-test.dixa.com",
		"development.dixa.com",
		"engineering.dixa.com"
	],
	default: {
		email: "dixa.com",
		emailIntegration: "email.dixa.io",
		integrations: "docs.dixa.io",
		service: "dixa.io",
		status: "status.dixa.io",
		subdomain: "demo",
		userContent: "dixausercontent.com",
		web: "dixa.com",
		accounts: "accounts.dixa.com",
		knowledge: "knowledge-backend-cdn",
		satisfactionSurveyPreview: "csat.reviews"
	}
}, m = {
	assets: `https://assets.${p.default.service}`,
	toolkit: `https://toolkit.${p.default.service}`,
	widget: `https://widget.${p.default.service}`,
	messenger: f === "prod" ? `https://messenger.${p.default.service}` : `https://messenger.${f}.${p.default.service}`,
	rest: `https://api.${d ?? p.default.service}`,
	advancedInsights: `https://api.${d ?? p.default.service}/v1/advanced-insights/`,
	partnerIntegrations: `https://partner-integrations.${d ?? p.default.service}`,
	files: `https://files.${d ?? p.default.service}`,
	webSocket: `wss://agent-sockets.${d ?? p.default.service}/v2/agent/`,
	userContent: d ? `https://raw.${d.replace(p.default.service, p.default.userContent)}` : `https://raw.${p.default.userContent}`,
	signUp: `https://${p.default.accounts}/signup`,
	logIn: `https://${p.default.accounts}/signin`,
	knowledgeCdn: f === "prod" ? `https://knowledge-backend-cdn.${p.default.service}` : `https://knowledge-backend-cdn.${f}.${p.default.service}`,
	knowledgeApi: `https://knowledge-backend.${d ?? p.default.service}`,
	satisfactionSurveyPreview: f === "prod" ? `https://${p.default.satisfactionSurveyPreview}/preview.html` : `https://stag.${p.default.satisfactionSurveyPreview}/preview.html`
}, h = {
	amplitude: { environment: [
		...p.test.automation,
		...p.develop,
		...p.test.security,
		...p.custom
	].includes(u) || f !== "prod" ? "stag" : "prod" },
	launchDarkly: p.develop.includes(u) ? "5ccbf1bfa9046808225e3998" : "5ccbf1bfa9046808225e3999",
	launchDarklyBackend: p.develop.includes(u) ? "6058545ab95b560e51acf129" : "6058545ab95b560e51acf12a",
	launchDarklyMiuros: p.develop.includes(u) ? "649ea8d43e6eca13a145c21f" : "649ea8d43e6eca13a145c220",
	stripe: p.develop.includes(u) ? "pk_test_jNReMBzv4cyXIBkSUrqaFtd0" : "pk_live_0b40LYRePjPZTtN9E9NbKixl",
	elevio: "599d54aacd7bd",
	birdeatsbug: "eee2fdfc-e7ee-4698-95fd-20e8cb83a4d5",
	jabra: {
		partnerKey: "4d2f-9cba7bbd-a9dd-4703-9847-c70a7df516ba",
		appId: "Dixa",
		appName: "Dixa"
	},
	messenger: { token: {
		prod: p.develop.includes(u) ? "95b2b555c0b046a18e5d508837811008" : "7c08132d4bf5d5f1bf4432133ef8254e3262f9ef",
		stag: "0a76a5650f3540dc8bad030e54aa2e22",
		stag2: "0a76a5650f3540dc8bad030e54aa2e22",
		dev1: "414a01b7802f4d4bb61a6ab6aaacd442",
		preprod: ""
	} }
}, g = {
	environment: f,
	domain: p.default,
	sdk: h,
	url: m,
	backendDomain: d
};
export { e as backendDomainMap, g as config, a as cookieKey, s as getBackendDomainCookie, t as isValidBackendDomain, o as parseBackendDomain, l as removeBackendDomainCookie, n as resolveEnvironment, c as setBackendDomainCookie };

//# sourceMappingURL=index.js.map